import { Component, OnDestroy, OnInit } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppMenuitem } from './app.menuitem';
import { AuthenticationService, PermissionHelperService } from '@core/services';
import {
  SessionActions,
  SessionState,
  selectProfile,
  selectSessionMenuItems,
} from '@app/core/state/session';

@Component({
  selector: '[app-menu]',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule, AsyncPipe],
  template: `<ul class="layout-menu">
    <ng-container *ngFor="let item of model$ | async; let i = index">
      <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
      <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
  </ul> `,
})
export class AppMenu implements OnInit, OnDestroy {
  model$ = this.store.select(selectSessionMenuItems);
  currentModule = 'central';
  subscription: Subscription = new Subscription();

  constructor(
    private authService: AuthenticationService,
    private permissionHelperService: PermissionHelperService,
    private router: Router,
    private store: Store<SessionState>,
  ) {
    this.navigationEnd()
      .pipe(take(1))
      .subscribe((url) => this.identifyModule(url));
  }

  ngOnInit() {
    this.subscription.add(
      this.store
        .select(selectProfile)
        .pipe(take(1))
        .subscribe(() =>
          this.store.dispatch(SessionActions.getMenuItems({ module: this.currentModule })),
        ),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  identifyModule(url: string) {
    if (url.startsWith('/customer')) {
      this.currentModule = 'tenant';
      return;
    }
    if (url.startsWith('/employee')) {
      this.currentModule = 'self-management';
      return;
    }
    this.currentModule = 'central';
  }

  changeModule() {
    if (!this.authService.isTenant()) {
      this.currentModule = 'central';
    }
    if (this.permissionHelperService.isSelfManagement()) {
      this.currentModule = 'self-management';
    } else {
      this.currentModule = 'tenant';
    }
  }

  navigationEnd() {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url),
    );
  }
}
